// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__tcRrP","head":"Table_head__1ypNr","col":"Table_col__16F41"};